import { Heart, Shield, Compass, Sun } from "lucide-react";

const focuses = [
  {
    icon: Heart,
    text: "Women returning to work",
  },
  {
    icon: Compass,
    text: "Women navigating confidence and visibility",
  },
  {
    icon: Sun,
    text: "Women seeking space to reconnect with themselves",
  },
  {
    icon: Shield,
    text: "Trauma-informed, sensitive facilitation environments",
  },
];

export default function WomenSection({ isVisible }) {
  return (
    <section
      id="women-only"
      className={`py-24 lg:py-32 bg-[#1A1A1A] transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      data-testid="women-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="responsive-image">
              <img
                src="https://images.unsplash.com/photo-1758273240403-052b3c99f636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHx3b21lbiUyMGNvbnZlcnNhdGlvbiUyMGNhbG18ZW58MHx8fHwxNzc1MzkwMjE4fDA&ixlib=rb-4.1.0&q=85"
                alt="Women in conversation"
                className="w-full h-auto object-cover"
                data-testid="women-section-image"
              />
            </div>
            {/* Decorative border */}
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-[#C5A059]/40 -z-10"></div>
          </div>

          {/* Text Content */}
          <div className="order-1 lg:order-2">
            <h2 className="font-['Cormorant_Garamond'] text-3xl sm:text-4xl lg:text-5xl font-medium text-[#F9F6F0] mb-6">
              Working with Women
            </h2>
            <div className="w-16 h-0.5 bg-[#C5A059] mb-8"></div>
            
            <p className="font-['Manrope'] text-base lg:text-lg text-[#EAE3D9] mb-8 leading-relaxed">
              I offer dedicated spaces for women to explore voice, confidence and
              identity in a supportive and structured environment.
            </p>

            <div className="space-y-5 mb-10">
              {focuses.map((focus, index) => (
                <div
                  key={index}
                  className="flex items-start"
                  data-testid={`women-focus-${index}`}
                >
                  <div className="w-10 h-10 bg-[#8B5A2B]/30 flex items-center justify-center mr-4 flex-shrink-0">
                    <focus.icon
                      size={20}
                      strokeWidth={1.5}
                      className="text-[#C5A059]"
                    />
                  </div>
                  <p className="font-['Manrope'] text-[#EAE3D9] pt-2">
                    {focus.text}
                  </p>
                </div>
              ))}
            </div>

            {/* Approach Note */}
            <div className="border-l-2 border-[#C5A059] pl-6 py-2">
              <p className="font-['Manrope'] text-sm text-[#C5A059] uppercase tracking-wider mb-2">
                My Approach
              </p>
              <p className="font-['Cormorant_Garamond'] text-lg text-[#F9F6F0] italic">
                Safe but structured. Emotion is welcomed and held responsibly.
                Focus on translating insight into real-world confidence.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
